export const REGISTRATION = 'registration';

export const CONTEXT_VALUE: {
    isRegistration?: boolean;
    isClubUpgrade?: boolean;
    isRetailWrapper?: boolean;
} = {
    isRegistration: true,
    isClubUpgrade: false,
    isRetailWrapper: false
};

export const BUTTON_FINISH_CLASS = 'ButtonFinishRegistration';
export const ON_FOCUS_EMAIL_FIELD = 'ON_FOCUS_EMAIL_FIELD';
export const ON_BLUR_EMAIL_FIELD = 'ON_BLUR_EMAIL_FIELD';
export const RETAIL_PLATFORM = 'retailapp';
